/** @format */

var ih = ih || {};

(function ($) {
    ih.uiState = {
        disabled: false,

        /**
         * Get value
         *
         * @param {string} key
         * @param {mixed} [def]
         * @returns {mixed}
         */
        get: function (key, def) {
            if (this.disabled) {
                console.error("ih.uiState is disabled");
                return undefined;
            }
            if (typeof ih.uiStates[key] === "undefined") {
                return typeof def === "undefined" ? null : def;
            }

            return ih.uiStates[key];
        },

        /**
         * Set value
         *
         * @param {string} key
         * @param {mixed} value
         * @returns {uiState}
         */
        set: function (key, value) {
            if (this.disabled) {
                console.error("ih.uiState is disabled");
                return this;
            }
            var _this = this;
            var oldValue = this.get(key);
            var url = ih.url("/AjaxUser/put_ui_state");

            //            console.log("URL", url);

            $.post(url, {
                key: key,
                value: value,
            })
                .done(function (response) {
                    if (!response.success) {
                        _this._error(key, oldValue, response.message);
                    }
                })
                .fail(function (xhr, status, message) {
                    _this._error(key, oldValue, message, xhr.status);
                });

            return this._write(key, value);
        },

        /**
         * Delete item
         *
         * @param {string} key
         * @returns {uiState}
         */
        delete: function (key) {
            if (this.disabled) {
                console.error("ih.uiState is disabled");
                return this;
            }

            var _this = this;
            var oldValue = this.get(key);
            var url = ih.url("/AjaxUser/delete_ui_state");

            //            console.log("URL", url);

            $.post(url, {
                key: key,
            })
                .done(function (response) {
                    if (!response.success) {
                        _this._error(key, oldValue, response.message);
                    }
                })
                .fail(function (xhr, status, message) {
                    _this._error(key, oldValue, message, xhr.status);
                });

            return this._delete(key);
        },

        /**
         * Deletes a list of items
         *
         *  @param {array} keys
         *
         * @returns {uiState}
         */
        deleteBulk: function (keys) {
            if (this.disabled) {
                console.error("ih.uiState is disabled");
                return this;
            }

            var oldUiStates = ih.uiStates;
            var url = ih.url("/AjaxUser/delete_ui_states");

            $.post(url, { keys: keys })
                .done(function (response) {
                    if (!response.success) {
                        console.error(response.message);
                        ih.uiStates = oldUiStates;
                    }
                })
                .fail(function (xhr, status, message) {
                    console.error(message);
                    ih.uiStates = oldUiStates;
                });

            return this._deleteBulk(keys);
        },

        /**
         * Delete all items
         *
         * @returns {uiState}
         */
        deleteAll: function () {
            if (this.disabled) {
                console.error("ih.uiState is disabled");
                return this;
            }

            var oldUiStates = ih.uiStates;
            var url = ih.url("/AjaxUser/delete_all_ui_states");

            $.post(url)
                .done(function (response) {
                    if (!response.success) {
                        console.error(response.message);
                        ih.uiStates = oldUiStates;
                    }
                })
                .fail(function (xhr, status, message) {
                    console.error(message);
                    ih.uiStates = oldUiStates;
                });

            return this._deleteAll();
        },

        /**
         * Update local states object
         *
         * @param {string} key
         * @param {mixed} value
         * @returns {uiState}
         * @private
         */
        _write: function (key, value) {
            ih.uiStates[key] = value;

            return this;
        },

        /**
         * Update local states object
         *
         * @param {string} key
         * @returns {uiState}
         * @private
         */
        _delete: function (key) {
            delete ih.uiStates[key];

            return this;
        },

        /**
         * Update local states object
         *
         * @param {array} keys
         * @returns {uiState}
         * @private
         */
        _deleteBulk: function (keys) {
            for (var i = 0; i < keys.length; i++) {
                delete ih.uiStates[keys[i]];
            }

            return this;
        },

        /**
         * Update local states object
         *
         * @returns {uiState}
         * @private
         */
        _deleteAll: function () {
            ih.uiStates = {};

            return this;
        },

        /**
         * Undo changes and show an error
         *
         * @param {string} key
         * @param {mixed} oldValue
         * @param {string} message
         * @param {integer} status
         * @returns {uiState}
         * @private
         */
        _error: function (key, oldValue, message, status) {
            //            ih.ajax.handleError(message, status);

            console.error(message, status);
            this.disabled = true;

            return this._write(key, oldValue);
        },
    };

    // on DOM loaded, check to make sure that ih.uiStates is not undefined.
    // If it IS, then we need to disable the uiState functionality.
    if (typeof ih.uiStates == "undefined") {
        //        console.error("ih.uiStates is undefined, disabling...");
        ih.uiState.disabled = true;
    }
})(window.jQuery);
